<template>
  <div :class="is_loading ? 'disabled-block' : ''">
    <upload
      :accept="accept"
      :format="format"
      action="/"
      :multiple="false"
      :show-upload-list="false"
      v-bind="$listeners"
      :before-upload="before_upload"
      type="drag"
      class="dnd-uploader"
      :disabled="is_loading"
    >
      <div
        v-if="file_preview.name"
        class="dnd-uploader__drop-zone flex flex--center flex--row-center"
      >
        <icon type="md-document" size="52" class="drop-zone__icon mr-2" />
        <div class="text-cut file-name">{{ file_preview.name }}</div>
      </div>

      <div v-else class="dnd-uploader__drop-zone">
        <div v-if="is_loading" class="drop-zone__loader">
          <spin size="large" />
        </div>

        <icon v-if="!is_loading" type="ios-cloud-upload" size="52" class="drop-zone__icon" />

        <p class="text-center text-muted">{{ $t('shared.component.file_upload.drag') }}</p>
      </div>
    </upload>
    <p class="small text-muted mb-0 mt-4">
      {{ $t('shared.component.file_upload.format') }}: {{ format_user }}.
    </p>

    <p v-for="rule in rules" :key="rule" class="small text-muted mb-0">
      {{ $t(`shared.component.file_upload.${rule}`) }}
    </p>
  </div>
</template>

<script>
  export default {
    props: {
      is_loading: {
        type: Boolean,
        default: false
      },
      formats: {
        type: Array,
        default: () => []
      },
      rules: {
        type: Array,
        default: () => []
      },
      max_file_size: {
        type: Number,
        default: 1
      }
    },
    data: () => ({
      file_preview: { name: '' },
      accept: [],
      format_user: [],
      format: []
    }),

    created() {
      this.accept = this.formats.map((i) => `.${i}`).join(',');
      this.format_user = this.formats.map((i) => `.${i}`).join(', ');
      this.format = this.formats;
    },

    methods: {
      before_upload(file) {
        const valid_file =
          this.formats.filter((format) => file.name?.includes(`.${format}`))?.length > 0;

        if (file.size < this.max_file_size && valid_file) {
          this.file_preview = file;
          this.$emit('before_upload', file);
          this.file_preview = {};
        } else if (file.size > this.max_file_size) {
          const warning_msg = this.$t('core.document.error.max_size', { filename: file.name });
          this.$noty.warning(warning_msg);
        } else if (!valid_file) {
          this.$noty.warning(this.$t('shared.component.file_upload.invalid_format'));
        }
        return false;
      }
    }
  };
</script>

<style lang="scss">
  .dnd-uploader {
    &__drop-zone {
      min-height: 114px;
      padding: 20px 0;

      .text-center {
        margin: 0 5px;
      }
    }
  }

  .drop-zone__loader {
    height: 52px;
    width: 52px;
    margin: 0 auto;
  }

  .drop-zone__icon {
    color: $primary;
  }
</style>
